import { motion, MotionValue, useTransform } from 'framer-motion';

import HeartSimpleShape from '@/components/common/svg/shapes/HeartSimpleShape';
import CloseShape from '@/components/common/svg/shapes/CloseShape.tsx';

export const SwipeAnimation = ({ x }: { x: MotionValue<number> }) => {
  const scaleRight = useTransform(x, [0, 50], [0.8, 1.2]);
  const opacityRight = useTransform(x, [0, 50], [0, 1]);

  const scaleLeft = useTransform(x, [0, -50], [0.8, 1.2]);
  const opacityLeft = useTransform(x, [0, -50], [0, 1]);

  const overlayOpacity = useTransform(x, [-150, 0, 150], [0.5, 0, 0.5]);

  const HeartAnimation = (
    <motion.div
      style={{
        position: 'absolute',
        top: '40%',
        left: '45%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        zIndex: 1000,
        scale: scaleRight,
        opacity: opacityRight,
        willChange: 'transform, opacity'
      }}
    >
      <motion.div
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
        }}
      >
        <HeartSimpleShape
          width={33}
          height={33}
          fillColor="#4C4C4C"
          style={{ marginTop: 3 }}
        />
      </motion.div>
    </motion.div>
  );

  const CrossAnimation = (
    <motion.div
      style={{
        position: 'absolute',
        top: '40%',
        left: '45%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        zIndex: 1000,
        scale: scaleLeft,
        opacity: opacityLeft,
        willChange: 'transform, opacity'
      }}
    >
      <motion.div
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
        }}
      >
        <CloseShape width={33} height={33} fillColor="#ffffff" />
      </motion.div>
    </motion.div>
  );

  const DarkOverlay = (
    <motion.div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        backgroundColor: '#000',
        opacity: overlayOpacity,
        pointerEvents: 'none',
        borderRadius: 'inherit',
        willChange: 'opacity'
      }}
    />
  );

  return (
    <>
      {DarkOverlay}
      {HeartAnimation}
      {CrossAnimation}
    </>
  );
};